import { components } from '@/utils'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${this.serviceName}.labels.title`),
        dense: true,
        clearable: true,
        required: true,
        details: false,
        autofocus: true,
        mask: /^.{0,255}$/
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}

function renderSwitch(h) {
  if (this.showSwitch) {
    return h(
      components.switch,
      {
        props: {
          value: this.proxy.isActive,
          outline: true,
          disabled: this.disabled,
          tooltip: this.getTranslate(`${this.serviceName}.tooltips.isActive`)
        },
        on: {
          input: event => {
            this.proxy.isActive = event
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { 'grid-template-columns': this.gridTemplateColumns }
    },
    [
      renderTitleField.call(this, h),
      renderSwitch.call(this, h)
    ]
  )
}
